import React from 'react';
import { motion } from 'framer-motion';

function App() {
  return (
    <div className="h-full w-full relative bg-radial-cinematic font-sans selection:bg-recording-red selection:text-white flex flex-col items-center justify-center px-6">
      
      {/* Top Header / Logo - Anchored Top Center */}
      <div className="absolute top-12 left-1/2 -translate-x-1/2 z-20">
        <h2 className="text-[14px] font-bold tracking-widest text-white uppercase opacity-90">
          StudioClip
        </h2>
      </div>

      {/* Main Cinematic Content */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 1.5, 
          ease: [0.16, 1, 0.3, 1] // Premium cubic-bezier out (Apple keynote style)
        }}
        className="flex flex-col items-center max-w-5xl w-full z-10"
      >
        {/* Hero Section */}
        <div className="text-center flex flex-col items-center mb-14 w-full">
          <h1 className="text-5xl md:text-[80px] lg:text-[100px] font-bold tracking-ultra-tight text-metallic mb-6 leading-[1.05]">
            The heavy lifting,<br className="hidden md:block" /> executed locally.
          </h1>
          <p className="text-silver-gray text-[18px] md:text-[22px] max-w-[650px] leading-relaxed font-normal">
            A premium macOS utility that cuts 16:9 widescreen long-form and 9:16 vertical video entirely on your Apple Silicon hardware. Zero cloud costs, zero rendering delays, and zero privacy risks.
          </p>
        </div>

        {/* Action Zone (Standalone CTA) */}
        <div className="w-full flex justify-center">
          <a
            href="https://formrobin.com/f/39o02k3"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-recording-red hover:bg-[#A30000] transition-colors duration-300 text-white font-bold text-[14px] tracking-wider uppercase px-[36px] py-[18px] rounded-[4px] inline-block shadow-none border-none outline-none cursor-pointer"
          >
            REQUEST EARLY ACCESS
          </a>
        </div>
      </motion.div>

      {/* Footer - Anchored to bottom */}
      <div className="absolute bottom-10 w-full text-center z-20">
        <p className="text-[#555555] text-[12px] tracking-widest uppercase font-medium">
          Built exclusively for macOS (M1+)
        </p>
      </div>

    </div>
  );
}

export default App;